import axios from 'axios';
import ApiConstants from '../../utils/apiConstants';
axios.defaults.withCredentials = true

// const BASE_URL = "https://geb-alpha.vercel.app/api";
const BASE_URL = ApiConstants.BACKEND_BASE_URL;

export default axios.create({
    baseURL: BASE_URL, withCredentials: true
});